export default [
  { id: 1, name: "Как заказать" },
  { id: 2, name: "Подобрать размер" },
  { id: 3, name: "Доставка и оплата" },
  { id: 4, name: "Обмен и возврат" },
]
